import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e77d3f4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "weather-popup",
  class: "light",
  ref: "weatherPopupEle"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-time" }
const _hoisted_4 = { class: "weather" }
const _hoisted_5 = { class: "chart" }
const _hoisted_6 = { class: "chart-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "weather-chart-container" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.weatherPopupData.city || '城市') + _toDisplayString(_ctx.weatherPopupData.name || '站点名'), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.moment(_ctx.weatherPopupData.issue,'YYYYMMDDHHmm').format("YY-MM-DD HH:mm:ss")), 1),
      _createElementVNode("div", {
        class: "iconfont icon-close close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeRankingVisable && _ctx.changeRankingVisable(...args)))
      })
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': _ctx.weatherFactorColorRender(_ctx.weatherPopupData.tem === null ? -9999 : Number(_ctx.weatherPopupData.tem), 'tem'),
          'color': _ctx.fontColorRender(Number(_ctx.weatherPopupData.tem), 'aqi')
          })
        }, " 气温 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.tem ? Number(_ctx.weatherPopupData.tem).toFixed(0) : '-') + "℃", 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': _ctx.weatherFactorColorRender(_ctx.weatherPopupData.pre_1h === null ? -9999 : Number(_ctx.weatherPopupData.pre_1h), 'pre'),
          'color': _ctx.fontColorRender(Number(_ctx.weatherPopupData.pre_1h), 'aqi')
          })
        }, " 降水 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.pre_1h ? Number(_ctx.weatherPopupData.pre_1h).toFixed(1) : '-') + "mm", 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': _ctx.weatherFactorColorRender(_ctx.weatherPopupData.rhu === null ? -9999 : Number(_ctx.weatherPopupData.rhu), 'rhu'),
          'color': _ctx.fontColorRender(Number(_ctx.weatherPopupData.rhu), 'aqi')
          })
        }, " 湿度 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.rhu ? Number(_ctx.weatherPopupData.rhu).toFixed(1) : '-') + _toDisplayString(_ctx.weatherPopupData.rhu ?'%': ''), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': 'rgb(155, 155, 155)',
          'color': 'rgb(23, 69, 0)'
          })
        }, " 风速 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.windS ?  Number(_ctx.weatherPopupData.windS).toFixed(1) : '-') + _toDisplayString(_ctx.weatherPopupData.windS ?'m/s': ''), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': 'rgb(155, 155, 155)',
          'color': 'rgb(23, 69, 0)'
          })
        }, " 风向 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.tem ? _ctx.windDirection(Number(_ctx.weatherPopupData.tem)) : '-'), 1)
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("div", {
          class: "upper",
          style: _normalizeStyle({
          'background-color': _ctx.weatherFactorColorRender(_ctx.weatherPopupData.pre_1h === null ? -9999 : Number(_ctx.weatherPopupData.prs), 'prs'),
          'color': _ctx.fontColorRender(Number(_ctx.weatherPopupData.prs), 'prs')
          })
        }, " 气压 ", 4),
        _createElementVNode("div", null, _toDisplayString(_ctx.weatherPopupData.prs ? Number(_ctx.weatherPopupData.prs).toFixed(1) : '-') + _toDisplayString(_ctx.weatherPopupData.prs ? 'hPa' : ''), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, "历史三天" + _toDisplayString(_ctx.factorKey[_ctx.popupData.infoWinType?.toUpperCase()]) + "变化图", 1),
      _hoisted_7
    ])
  ], 512)), [
    [_vShow, Object.keys(_ctx.weatherPopupData).length]
  ])
}